import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useFormularyStatusList from "./hooks/useFormularyStatusList";

const FormularyStatusList = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
}) => {
  const formularyStatusListData = useFormularyStatusList(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData
  );
  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={formularyStatusListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {formularyStatusListData.screen_title} -{" "}
          <span className="heading-cod">
            {formularyStatusListData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={formularyStatusListData.formFields}
        dropdownValues={formularyStatusListData.dropdownValues}
        paramsData={formularyStatusListData.paramsData}
        updataParamData={formularyStatusListData.updateParamData}
      />
      <ButtonsSection ctaButtons={formularyStatusListData.ctaButtons} />
      <DisplayTable
        data={formularyStatusListData.data}
        parmKey={formularyStatusListData.parmKey}
        menuOptions={formularyStatusListData.menuOptions}
        tableHeaders={formularyStatusListData.columnDef}
        setRowData={formularyStatusListData.setRowData}
        selectedPriceSchedules={formularyStatusListData.selectedRows}
        setSelectedPriceSchedules={formularyStatusListData.setSelectedRows}
        selectMode={formularyStatusListData.selectMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={formularyStatusListData.first}
          rows={formularyStatusListData.rows}
          totalRecords={formularyStatusListData.totalRecords}
          currentPage={formularyStatusListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={formularyStatusListData.onPageChange}
        />
      </div>
      {formularyStatusListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={formularyStatusListData.isConfirmationModalOpen}
          onRequestClose={formularyStatusListData.closeConfirmationModal}
          onBack={formularyStatusListData.closeConfirmationModal}
          onSave={formularyStatusListData.deleteFormularyStatus}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={formularyStatusListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default FormularyStatusList;
